import React from "react";
import Squiggle from "./Squiggle";

const steps = [
  {
    title: "Install Decision Tracker",
    bullets: [
      "Click Add to Slack and approve it for your workspace. No credit card required.",
    ]
  },
  {
    title: "Track your first decision",
    bullets: [
      "Right-click a Slack message and choose Track decision, or accept a suggestion when one appears.",
      "The title is filled in from the message, so most of the time you just press Track Decision.",
      "In public channels the app joins the first time you use it there. In private channels, invite it with /invite @Decision Tracker.",
      "Optionally add the stakeholders who should weigh in."
    ]
  },
  {
    title: "Let it answer the repeat questions",
    bullets: [
      "When someone asks about a decision you’ve tracked, Decision Tracker shows it to them under their message.",
      "Only the person who asked can see it.",
      "Search any time with /decide find <topic>."
    ]
  },
  {
    title: "Request approvals",
    bullets: [
      "From a decision, click Nudge Stakeholders to request sign-off.",
      "Approvers get approve and decline buttons with the context included."
    ]
  },
  {
    title: "Catch up on Mondays",
    bullets: [
      "One short digest: what’s waiting on you, what’s gone quiet, and what was decided.",
      "If nothing needs you, nothing is sent.",
      "The Home tab always has the full list."
    ]
  }
];

const quickAnswers = [
  ["What should I track?", "Decisions with lasting impact, several people involved, or an approval needed. Skip the trivial ones."],
  ["Can I edit or delete decisions later?", "Yes. Open a decision to change its title, description, stakeholders or linked conversations, or delete it."],
  ["Do approvers need to be in Slack?", "Yes. Approvals happen in Slack, so approvers need to be members of the workspace."],
];

const GettingStarted = ({ trialInstallLink, onCTAClick }) => (
  <div className="dt">
    <section className="dt-hero dt-page-hero">
      <div className="dt-wrap">
        <h1 className="dt-page-title">Up and running in <span className="dt-kept">five minutes<Squiggle /></span></h1>
        <p className="dt-hero-sub">Install the app, track one decision, and it starts working for the whole channel.</p>
        <div className="dt-cta-row">
          <a href={trialInstallLink} className="dt-btn dt-btn-primary" onClick={onCTAClick}>Add to Slack — free</a>
          <a href="/blog/getting-started-decision-tracker-tutorial" className="dt-btn dt-btn-quiet">Read the full tutorial</a>
        </div>
      </div>
    </section>

    <section className="dt-section dt-section--surface">
      <div className="dt-wrap">
        <ol className="dt-setup">
          {steps.map((step) => (
            <li key={step.title} className="dt-setup-step">
              <h2 className="dt-h3">{step.title}</h2>
              <ul className="dt-step-points">
                {step.bullets.map((b) => <li key={b}>{b}</li>)}
              </ul>
            </li>
          ))}
        </ol>
      </div>
    </section>

    <section className="dt-section">
      <div className="dt-wrap dt-faq">
        <h2 className="dt-h2">Quick answers</h2>
        <div className="dt-faq-list">
          {quickAnswers.map(([q, a]) => (
            <details className="dt-faq-item" key={q}>
              <summary>{q}</summary>
              <p>{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default GettingStarted;



// WEBPACK FOOTER //
// ./src/components/GettingStarted.js